import React from "react";
import { gql, useQuery } from "@apollo/client";
import InfiniteScroll from "react-infinite-scroll-component";

import { Container, List, Avatar, Stack, Typography } from "@mui/material";
import { AccountMultiple as UsersIcon } from "mdi-material-ui";

import Layout from "components/common/Layout";
import SearchInput from "components/common/SearchInput";
import UserListItem from "components/user/UserListItem";

const QUERY = gql`
  query ($first: Int, $after: String, $search: String) {
    users(first: $first, after: $after, search: $search) {
      pageInfo {
        hasNextPage
        endCursor
      }

      edges {
        cursor
        node {
          id

          ...UserListItem_User
        }
      }
    }
  }

  ${UserListItem.fragments.user}
`;

export default function UsersPage() {
  const [search, setSearch] = React.useState("");

  const { data, loading, fetchMore } = useQuery(QUERY, {
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-first",
    variables: { first: 20, search },
  });

  return (
    <Container fixed>
      <Layout.Toolbar fixed>
        <Stack spacing={2} direction="row" alignItems="center">
          <Avatar>
            <UsersIcon />
          </Avatar>

          <Typography variant="h4" color="primary" sx={{ flexGrow: 1 }}>
            Utilisateurs
          </Typography>

          <SearchInput onChange={setSearch} />
        </Stack>
      </Layout.Toolbar>

      <List>
        <InfiniteScroll
          scrollableTarget="Layout-Main"
          dataLength={data?.users.edges.length ?? 0}
          next={() =>
            fetchMore({
              variables: { after: data?.users.pageInfo.endCursor },
            })
          }
          loader={<Layout.Loading />}
          hasMore={data?.users.pageInfo.hasNextPage ?? loading}
        >
          {data?.users.edges.map(({ cursor, node }) => (
            <UserListItem key={cursor} user={node} />
          ))}
        </InfiniteScroll>
      </List>
    </Container>
  );
}
